export enum ModalFormStatus {
    Iddle = 'IDDLE',
    Pending = 'PENDING',
    Finished = 'FINISHED',
    Error = 'ERROR'
}
